module.exports = __webpack_public_path__ + "static/img/logo.9091f22f.png";